import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
	(state) => state.authorization,
	(authorization) => authorization
);
export const getCurrentRoute = createSelector(
	(state) => state.currentRoute,
	(currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
	getCurrentRoute,
	(route) => route.title
);
export const getSideMenuState = createSelector(
	(state) => state.app,
	(app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
	(state) => state.currentTheme,
	(currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
	(state) => state.profile,
	(profile) => profile
);
export const currentUserId = createSelector(
	(state) => state.profile,
	(profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
	!profile ? null : ROLES_RAW.includes(profile.role) ? profile.role : null
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
	(state) => state.notifications,
	(notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
	(state) => state.users,
	(users) => users
);
export const getUsersForm = createSelector(
	(state) => state.usersForm,
	(form) => form
);

/* ALERT */
export const getAlerts = createSelector(
	(state) => state.alerts,
	(alerts) => alerts
);
export const getAlertsForm = createSelector(
	(state) => state.alertsForm,
	(form) => form
);

/* CONSULTATIONS */
export const getConsultations = createSelector(
	(state) => state.consultations,
	(consultations) => consultations
);
export const getConsultationsForm = createSelector(
	(state) => state.consultationsForm,
	(form) => form
);

/* APPOINTMENTS */
export const getAppointments = createSelector(
	(state) => state.appointments,
	(appointments) => appointments
);
export const getAppointmentsForm = createSelector(
	(state) => state.appointmentsForm,
	(form) => form
);

/* REVIEWS */
export const getReviews = createSelector(
	(state) => state.reviews,
	(reviews) => reviews
);
export const getReviewsForm = createSelector(
	(state) => state.reviewsForm,
	(form) => form
);

/* SUBSCRIPTIONS */
export const getSubscriptions = createSelector(
	(state) => state.subscriptions,
	(subscriptions) => subscriptions
);
export const getSubscriptionsForm = createSelector(
	(state) => state.subscriptionsForm,
	(form) => form
);

/* SUGGESTIONS */
export const getSuggestions = createSelector(
	(state) => state.suggestions,
	(suggestions) => suggestions
);
export const getSuggestionsForm = createSelector(
	(state) => state.suggestionsForm,
	(form) => form
);

/* CONTACTS */
export const getContacts = createSelector(
	(state) => state.contacts,
	(contacts) => contacts
);
export const getContactsForm = createSelector(
	(state) => state.contactsForm,
	(form) => form
);

/* REFERRALS */
export const getReferrals = createSelector(
	(state) => state.referrals,
	(referrals) => referrals
);
export const getReferralsForm = createSelector(
	(state) => state.referralsForm,
	(form) => form
);
